import React, {Component} from 'react';
import MainImageLoader from "./containers/MainImageLoader";

class App extends Component {
    render() {
        return (
            <div>
                <MainImageLoader/>
            </div>
        );
    }
}

export default App;
